// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3jMge","productName":"Table_productName__1_NKz"};